// UTM + tracking capture and persistence.
// Reads URL params on first landing, stores in localStorage, surfaces helper to
// merge into form payloads.

const KEY = "bscv_tracking";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

function read() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
}

function write(obj) {
  try {
    localStorage.setItem(KEY, JSON.stringify(obj));
  } catch {
    /* ignore quota / private mode */
  }
}

export function captureTracking() {
  if (typeof window === "undefined") return;
  const params = new URLSearchParams(window.location.search);
  const stored = read();
  let dirty = false;
  for (const k of UTM_KEYS) {
    const v = params.get(k);
    if (v && !stored[k]) {
      stored[k] = v;
      dirty = true;
    }
  }
  if (!stored.landing_page) {
    stored.landing_page = window.location.href;
    dirty = true;
  }
  if (!stored.referrer_url && document.referrer) {
    stored.referrer_url = document.referrer;
    dirty = true;
  }
  if (dirty) write(stored);
  return stored;
}

export function getTracking() {
  const stored = read();
  return {
    utm_source: stored.utm_source || "",
    utm_medium: stored.utm_medium || "",
    utm_campaign: stored.utm_campaign || "",
    utm_content: stored.utm_content || "",
    utm_term: stored.utm_term || "",
    referrer_url: stored.referrer_url || (typeof document !== "undefined" ? document.referrer : ""),
    landing_page: stored.landing_page || (typeof window !== "undefined" ? window.location.href : ""),
    user_agent: typeof navigator !== "undefined" ? navigator.userAgent : "",
  };
}
